<div class="widget-container" #ChordChartDiv>
    <app-chord-chart
    [config]="config"
    [data]="data"
    [item]="item"
    [pageKey]="pageKey"
    [pageKey]="pageKey"
    [error_name]="error_name"
    (filterChange)="loadApiData($event)"
    >
    </app-chord-chart>
</div>